import { ReactNode, useMemo } from "react";

import { Encounter } from "@medplum/fhirtypes";

import { getEncounterServiceDateKey } from "@/encounters/utils/encounter-timezone";
import { QuestionnaireCodingFilterContext } from "@/intake-forms/components/QuestionnaireChoiceField/QuestionnaireCodingFilterContext";

import { getProcedureCodingFilters } from "../utils/procedure-code-filters";

/**
 * Limits the procedure code search of a CPT code questionnaire inside it to the codes billable on
 * the encounter's service date, the same rule as the procedure picker. Used by the questionnaire
 * procedures and billing drawers.
 */
export function ProcedureCodingFilterProvider({
  encounter,
  children,
}: {
  encounter: Encounter | undefined;
  children: ReactNode;
}) {
  const serviceDate = getEncounterServiceDateKey(encounter);
  const codingFilters = useMemo(() => getProcedureCodingFilters(serviceDate), [serviceDate]);

  return (
    <QuestionnaireCodingFilterContext.Provider value={codingFilters}>
      {children}
    </QuestionnaireCodingFilterContext.Provider>
  );
}
